export default __webpack_public_path__ + "static/media/SP.1b478754.pdf";